import Loading from "@/components/ui/loading";
import { OrganizationInvitation } from "@/features/organization-invitations";
import { useGetAccessToken } from "@/lib/apollo/getAccessToken";
import { createFileRoute, NavigateOptions } from "@tanstack/react-router";

type InvitationSearch = {
  redirect: NavigateOptions | undefined;
};

export const Route = createFileRoute("/_auth/invitation/$invitationId")({
  component: OrganizationInvitationPage,
  validateSearch: (search: Record<string, unknown>): InvitationSearch => ({
    redirect: (search.redirect as NavigateOptions) || undefined
  })
});

function OrganizationInvitationPage() {
  const { invitationId } = Route.useParams();
  const { token } = useGetAccessToken();

  if (!token)
    return (
      <div className="h-screen w-full flex justify-center items-center dark:bg-brand-gray-950">
        <Loading size="md" />
      </div>
    );
  return (
    <div className="w-full flex justify-center items-center dark:bg-brand-gray-950 bg-white m-1.5 rounded-lg dark:border dark:border-brand-gray-900">
      <OrganizationInvitation invitationId={invitationId} />
    </div>
  );
}
